"use client";
import { clsx as r } from "clsx";
import { twMerge as o } from "tailwind-merge";
function c(...t) {
  return o(r(t));
}
const i = (t) => t ? "" : void 0;
export {
  c as cn,
  i as dataAttr
};
